import { PriceWrapper } from "@/app/price"
import type { NftId } from "@anaconda/core/nft/types"
import { Skeleton } from "@rarible_int/anaconda_ui_components"
import { useCollectionNftsSellState } from "../../../use-collection-nfts-sell.reatom"

interface Props {
  nft: NftId
}
export function MatchedOffer({ nft }: Props) {
  const { offerByNftAtom } = useCollectionNftsSellState()
  const offerByNft = offerByNftAtom()
  const matchedOffer = offerByNft[nft]

  if (!matchedOffer) {
    return <span>-</span>
  }

  if (matchedOffer.offersLoading) {
    return <MatchedOfferSkeleton />
  }

  if (matchedOffer.offer) {
    return <PriceWrapper {...matchedOffer.offer.price} />
  }
}

export function MatchedOfferSkeleton() {
  return <Skeleton className="h-5 w-10" />
}
